import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC, Fragment } from 'react'

import { Link } from '@Components/Link'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductsAndCaption.module.scss'

export interface Product {
  id: string
  link: string
  title: string
}

interface ProductCaptionProps {
  caption?: string
  products: Product[]
}

const getPostProductsChar = (productsLength: number, index: number) => {
  if (index < productsLength - 2) {
    return ', '
  }
  if (index === productsLength - 2) {
    return ' & '
  }
  return ''
}

export const ProductsAndCaption: FC<ProductCaptionProps> = ({
  caption,
  products,
}: ProductCaptionProps) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(styles.productsAndCaption, !!caption && styles.withCaption)}>
      {products.length > 0 && (
        <div className={styles.productNames}>
          {t('cms:CMS_IMAGE_MODULE_SHOWING_LABEL')}
          {' '}
          {map(products, (product, index) => (
            <Fragment key={product.id}>
              <Link
                analytics={{
                  dest_page_type: 'product',
                  dest_page_type_id: product.id,
                  source_id: 'image_module_caption',
                }}
                href={product.link}
              >
                {product.title}
              </Link>
              {getPostProductsChar(products.length, index)}
            </Fragment>
          ))}
        </div>
      )}
      {caption && (
        <div className={styles.imageCaption} dangerouslySetInnerHTML={{ __html: caption }} />
      )}
    </div>
  )
}
